module.exports = __webpack_public_path__ + "img/MIR.0062e8fa.svg";